import { HeaderGroup } from 'react-table';
import { TableHeaderColumn } from './TableHeaderColumn'; // Adjust path as needed
import { ReactNode } from 'react';

type TableHeadProps<T extends object> = {
  headerGroups: HeaderGroup<T>[];
  // Optional sort state props if not using Zustand internally
  sort?: string;
  order?: 'asc' | 'desc';
  updateState?: (state: { sort?: string; order?: 'asc' | 'desc' }) => void;
  preline?: ReactNode
};

export const TableHead = <T extends object>({
  headerGroups,
  sort,
  order,
  updateState,
  preline,
}: TableHeadProps<T>) => {
  return (
  <thead>
    {preline ?? null}
    {headerGroups.map((headerGroup) => {
      // 1. Extract row key separately from headerGroup props
      const { key: groupKey, ...restGroupProps } = headerGroup.getHeaderGroupProps();

      return (
        <tr
          key={groupKey}
          {...restGroupProps}
          className="text-start text-muted fw-bolder fs-7 text-uppercase gs-0"
        >
          {headerGroup.headers.map((column) => (
            <TableHeaderColumn
              key={column.id}
              column={column}
              sort={sort}
              order={order}
              updateState={updateState}
            />
          ))}
        </tr>
      );
    })}
  </thead>
  );
};